import lz from 'lzutf8'
import React from 'react'

import { Editor, Frame } from '@craftjs/core'

import { NotFoundError } from 'utils/customError'

import AksiNyata from 'components/CLWidgets/AksiNyata'
import Assessment from 'components/CLWidgets/Assessment'
import Button from 'components/CLWidgets/Button'
import Container from 'components/CLWidgets/Container'
import ContentWrapper from 'components/CLWidgets/ContentWrapper'
import Document from 'components/CLWidgets/Document'
import GenericPageCard from 'components/CLWidgets/GenericPageCard'
import Heading from 'components/CLWidgets/Heading'
import Image from 'components/CLWidgets/Image'
import Module from 'components/CLWidgets/Module'
import PageCard from 'components/CLWidgets/PageCard'
import Text from 'components/CLWidgets/Text'
import Toolkit from 'components/CLWidgets/Toolkit'
import Topic from 'components/CLWidgets/Topic'
import VideoCard from 'components/CLWidgets/VideoCard'

import type { CLItem, CLWidgetSchema } from 'typings/microlearning'

export interface CLRendererProps {
  clItem: CLItem
  topicId?: number
  topicName?: string
  trackerWidgetData?: {
    source: 'reference_tab' | 'kb_page'
    kbPageId: string
  }
}

const CLRenderer = ({
  clItem,
  topicId,
  topicName,
  trackerWidgetData,
}: CLRendererProps) => {
  const widgetObjects = clItem?.widgetObjects ?? []

  const rawSchemaString: string = lz.decompress(
    lz.decodeBase64(clItem?.contentSchema)
  )
  const rawSchema: CLWidgetSchema = JSON.parse(
    rawSchemaString.length > 0 ? rawSchemaString : '{}'
  )

  let schemaString = '{}'
  let shouldRenderFrame = schemaString !== '{}'

  try {
    Object.keys(rawSchema).forEach((widgetId) => {
      if (widgetId !== 'ROOT') {
        const widget = rawSchema[widgetId]
        widget.props = {
          ...widget.props,
          trackerWidgetData: {
            ...trackerWidgetData,
            widgetValue: widget.props,
            widgetType: widget.custom?.name,
            widgetId,
          },
        }
      }
    })

    if (widgetObjects.length > 0 && rawSchemaString.length > 0) {
      widgetObjects.forEach((widgetObject) => {
        /**
         * TODO: revisit this one
         * Somehow the linter rejecting `structuredClone()`
         * --
         * use `JSON.stringify()` and `JSON.parse()` instead
         * */
        const responseData = JSON.parse(
          JSON.stringify(widgetObject.responseData)
        )
        rawSchema[widgetObject.widgetNode].props = {
          ...rawSchema[widgetObject.widgetNode].props,
          ...responseData,
          topicId,
          topicName,
          trackerWidgetData: {
            ...rawSchema[widgetObject.widgetNode].props.trackerWidgetData,
            widgetValue: responseData,
          },
        }
      })
    }

    schemaString = JSON.stringify(rawSchema)
    shouldRenderFrame = schemaString !== '{}'
  } catch (e) {
    throw new NotFoundError(window.location.pathname, e)
  }

  return (
    <Editor
      resolver={{
        AksiNyata,
        Assessment,
        Button,
        Container,
        ContentWrapper,
        Document,
        Heading,
        Image,
        Module,
        PageCard,
        GenericPageCard,
        Text,
        Toolkit,
        Topic,
        VideoCard,
      }}
      enabled={false}
    >
      {shouldRenderFrame && <Frame data={schemaString} key={clItem.id} />}
    </Editor>
  )
}

export default CLRenderer
